<script lang="ts">
  export let width: number = 130;
  export let height: number = 80;
  export let className: string = "";
  // Font Awesome solid icons preferred
  export let leftIconClass: string = "fa-solid fa-landmark"; // Berlin
  export let rightIconClass: string = "fa-solid fa-city";    // Amsterdam

  export let distanceText: string;
</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
  <svg
    {width}
    {height}
    viewBox="0 0 130 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Berlin to Amsterdam passport stamp"
    class={className}
  >
    <title>Berlin to Amsterdam Passport Stamp</title>

    <!-- Geometry helpers -->
    <defs>
      <!-- Upper arc for curved text 'BERLIN TO' -->
      <path id="upperArc" d="M 18 33 A 52 28 0 0 1 112 33" />
      <!-- Lower arc for curved text 'AMSTERDAM' -->
      <path id="lowerArc" d="M 18 47 A 52 28 0 0 0 112 47" />
      <!-- Inner hex path for scalloped dash -->
      <path id="innerHexPath" d="M 16 40 L 31 20 L 99 20 L 114 40 L 99 60 L 31 60 Z" />
    </defs>

    <!-- Outer hexagon border -->
    <polygon
      points="5,40 20,3 110,3 125,40 110,71 20,71"
      fill="none"
      stroke="#000"
      stroke-width="1.8"
    />

    <!-- Inner hexagon thin rule -->
    <polygon
      points="10,40 24,7 106,7 120,40 106,67 24,67"
      fill="none"
      stroke="#000"
      stroke-width="0.9"
      opacity="0.95"
    />

    <!-- Light inner guilloche (scalloped beads) along inner hex path -->
    <use href="#innerHexPath" fill="none" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-dasharray="0.25 4" opacity="0.85" />

    <!-- Center ribbon band for distance text (kept black via low opacity fill) -->
    <rect x="20" y="34" width="90" height="12" rx="3" ry="3" fill="#000" opacity="0.08" />

    <!-- Route line (dashed) -->
    <!-- <path d="M 32 40 L 98 40" stroke="#000" stroke-width="1.2" stroke-dasharray="3 2" opacity="0.85" /> -->
    <!-- Arrow chevron in the middle for direction -->
    <!-- <path d="M 65 38 L 68 40 L 65 42" fill="none" stroke="#000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /> -->

    <!-- Curved texts -->
    <text fill="#000" font-size="9" font-weight="900" letter-spacing="2" text-anchor="middle" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.6;">
      <textPath href="#upperArc" startOffset="50%">BERLIN TO</textPath>
    </text>
    <text fill="#000" font-size="9" font-weight="900" letter-spacing="2" text-anchor="middle" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.6;">
      <textPath href="#lowerArc" startOffset="50%">AMSTERDAM</textPath>
    </text>

    <!-- Distance value on ribbon -->
    <g transform="translate(65,40)">
      <text x="0" y="3" fill="#000" font-size="8" font-weight="700" text-anchor="middle" style="letter-spacing:1px;">{distanceText}</text>
    </g>
  </svg>

  <!-- Font Awesome icons overlay for landmarks (pure black) -->
  <!-- Berlin (left) -->
  <div class="absolute" style="top: calc(50% - 5px); left: 26px; transform: translate(-50%, -50%); color:#000;">
    <i class={leftIconClass} style="font-size:16px; line-height:1; color:#000; opacity:0.95;"></i>
  </div>
  <!-- Amsterdam (right) -->
  <div class="absolute" style="top: calc(50% - 5px); left: 104px; transform: translate(-50%, -50%); color:#000;">
    <i class={rightIconClass} style="font-size:16px; line-height:1; color:#000; opacity:0.95;"></i>
  </div>
</div>
